import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: string;
  onChange: (v: string) => void;
}

const ColorField: React.FC<Props> = ({ label, description, value, onChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <input
      type="color"
      value={value || '#000000'}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: 36, height: 36, border: '1px solid #D3D6DC', borderRadius: 6, cursor: 'pointer', padding: 2 }}
    />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
      {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F' }}>{description}</Typography>}
    </Box>
    <TextField
      size="small"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder="#000000"
      InputProps={{ sx: { fontSize: 13, borderRadius: '6px', fontFamily: 'monospace', width: 120 } }}
    />
  </Box>
);

export default ColorField;
